// extracted by mini-css-extract-plugin
export var searchHeader = "_a5-0";
export var searchHeaderDark = "_a5-1";